import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/GlobalContext';
import AccessibleContent from '../../utils/AccessibleContent';

const CGUView = ({ store }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage } = useGlobalContext();
  const lang = currentLanguage ? currentLanguage.code : '';

  return (
    <div className="content">
      <div id="topSection">
        <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
          <div className="wrapper">

            <AccessibleContent
              htmlContent={store.texteAccroche && store.texteAccroche[lang]
                ? store.texteAccroche[lang].replace("<p>", "<h2>").replace("</p>", "</h2>")
                : `<h2>${t("Recevez votre carte cadeau")}</h2>`}
              className="headContent accrocheColor"
            />
            {!store.exception && (
              <div className="showMoreBox">
                <a href="#" onClick={() => navigate('/details')} translate="true">
                  {t("En savoir plus")}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mainContent">
        <div className="wrapper mainWhiteBox">
          <div className="buttonAction">
            <a
             href="/home"
              className="buyCard returnToHome"
            >
              {t("Acheter une e carte cadeau")}
            </a>
          </div>
          <div className="contentBody mainColor pt64">
            <AccessibleContent
              htmlContent={store.cgu[lang] ? store.cgu[lang] : ""}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGUView;
